import React, { useState, useCallback, useRef, useEffect } from 'react';
import BlockExternalUsersAuditLogView from './block-external-users-audit-log.view';
import { useUpdateSubcontractorDBContext } from 'src/contexts/manage-subcontractor.context';
import { IORGDataTableQueryState } from 'shared-it-appmod-ui';

type Iprops = {
    openAuditLogs: boolean;
    handleOnDiscardAuditLogs: () => void;
};
const BlockExternalUsersAuditLog: React.FC<Iprops> = ({
    openAuditLogs,
    handleOnDiscardAuditLogs,
}) => {
    const { state, actions } = useUpdateSubcontractorDBContext();
    const [loadinglog, setLoadinglog] = useState(false);
    const [queryParams, setQueryParams] = useState<IORGDataTableQueryState>();
   
    const fetchLogData = useCallback(
        async (params: IORGDataTableQueryState) => {
            setLoadinglog(true);

            const { page, limit } = params;
            const param =
                {
                    page: page,
                    limit: limit
                } || queryParams;
            await actions?.blockAndUnblockExternalUserAuditLogGet(param);
            setLoadinglog(false);
        },
        [actions]
    );



    const handleCancel = useCallback(() => {
        handleOnDiscardAuditLogs();
    }, []);
    return (
        <>
            <BlockExternalUsersAuditLogView
                data={state?.blockAndUnblockExternalUserAuditLogGet?.data || []}
                openAuditLogs={openAuditLogs}
                handleClose={handleCancel}
                loadinglog={loadinglog}
                fetchLogData={fetchLogData}
                totalRecord={state?.blockAndUnblockExternalUserAuditLogGet?.total_rows || 0}
            />

        </>
    );
};

export default BlockExternalUsersAuditLog;
